const passwordValidationsMessages = {
  IS_LONG_ENOUGH: 'Must be at least 8 characters long.',
  HAS_UPPERCASE: 'Must contain at least one uppercase letter.',
  HAS_NUMBER: 'Must contain at least one number.',
  HAS_SPECIAL_CHARACTER: 'Must contain at least one special character.',
};

export default passwordValidationsMessages;
